<template>
    <v-content v-if="template">
        <v-row align="center" justify="center">
            <v-col align="right">
                <v-btn @click="saveTemplate">Сохранить</v-btn>
            </v-col>
            <v-col cols="12">
                <v-card>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                Название шаблона для рассылок
                                <v-text-field
                                    v-model="template.name"
                                    placeholder="Название"
                                    outlined
                                ></v-text-field>
                            </v-col>
                            <v-col>
                                <audioSelector :element="template.json" type="record" />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <ivrRepeat :element="template.json" />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12">
                <TreeChart :json="template.json" />
            </v-col>
        </v-row>
        <pre>
            {{ template.json }}
        </pre>
    </v-content>
</template>

<script>
import TreeChart from "../shared/components/treeChart";
import audioSelector from "../shared/components/audioSelector";
import ivrRepeat from "../shared/components/ivrRepeat";
export default {
    name: "callTemplate",
    components: {
        TreeChart,
        audioSelector,
        ivrRepeat,
    },
    data() {
        return {};
    },
    created() {
        if (this.templateId && this.action == "update") {
            this.template = this.templates.find((element) => {
                return element.id == this.templateId;
            });
            this.$store.dispatch("GET_TEMPLATE_BY_ID", this.templateId);
        }
    },
    computed: {
        templateId() {
            return this.$route.params.id;
        },
        action() {
            return this.$route.name == "UpdateTemplate" && this.templateId ? "update" : "create";
        },
        template: {
            get() {
                return this.$store.getters.CURRENT_TEMPLATE;
            },
            set(value) {
                this.$store.commit("SET_CURRENT_TEMPLATE", value);
            },
        },
        templates() {
            return this.$store.getters.TEMPLATES;
        },
    },
    methods: {
        saveTemplate() {
            if (this.action == "create") {
                this.$store
                    .dispatch("CREATE_TEMPLATE", this.template)
                    .then(() => {
                        this.$toaster.success("Шаблон создан");
                        this.$router.push({ path: "/call-templates" });
                    })
                    .catch(() => {
                        this.$toaster.error("Неизвестная ошибка!");
                    });
            } else {
                this.$store
                    .dispatch("UPDATE_TEMPLATE", this.template)
                    .then(() => {
                        this.$toaster.success("Шаблон сохранен");
                        this.$router.push({ path: "/call-templates" });
                    })
                    .catch(() => {
                        this.$toaster.error("Неизвестная ошибка!");
                    });
            }
        },
    },
};
</script>

<style></style>
